import { styled } from "goober";

export const FooterBadge = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  padding: 0 8px;
  margin-right: 2px;
  background: var(--alpha4);
  border-radius: 38px;
  white-space: nowrap;
  flex-shrink: 0;
`;
